// extracted by mini-css-extract-plugin
module.exports = {"msgLimit":"CreateSMS_msgLimit__1LgCS","patientName":"CreateSMS_patientName__30RSe"};